/**
 * Polish display labels for ArticleType enum values ("charakter artykułu").
 *
 * This file is the SINGLE SOURCE OF TRUTH for frontend article-character
 * labels and colors. It is reused by CallArticlesList.tsx, GrantsArticlesTab,
 * AddArticleToCallModal and FieldChangesTable, and MUST stay in sync with the
 * backend `ArticleType` enum.
 *
 * @see apps/backend/src/entities/grants-sourcing-article-to-call-mapping.entity.ts (ArticleType enum)
 */
export const articleRoleLabels: Record<string, string> = {
  CALL_ANNOUNCEMENT: "Ogłoszenie naboru",
  CALL_UPDATE: "Aktualizacja",
  CALL_EXTENSION: "Przedłużenie terminu",
  CALL_SUSPENSION: "Zawieszenie naboru",
  CALL_RESULTS: "Wyniki naboru",
  CALL_CLOSURE: "Zamknięcie naboru",
  PROJECT_INFO: "Informacje o projekcie",
  OTHER: "Inny",
  INFO_MEETING: "Spotkanie informacyjne",
  CALL_CANCELLATION: "Anulowanie naboru",
  DEADLINE_CHANGE: "Zmiana terminu",
};

/**
 * Tailwind color classes for ArticleType badges.
 * Matches the visual style used in CallArticlesList.
 */
export const articleRoleColors: Record<string, string> = {
  CALL_ANNOUNCEMENT: "bg-green-100 text-green-800",
  CALL_UPDATE: "bg-blue-100 text-blue-800",
  CALL_EXTENSION: "bg-amber-100 text-amber-800",
  CALL_SUSPENSION: "bg-orange-100 text-orange-800",
  CALL_RESULTS: "bg-purple-100 text-purple-800",
  CALL_CLOSURE: "bg-red-100 text-red-800",
  PROJECT_INFO: "bg-teal-100 text-teal-800",
  OTHER: "bg-neutral-100 text-neutral-700",
  INFO_MEETING: "bg-indigo-100 text-indigo-800",
  CALL_CANCELLATION: "bg-rose-100 text-rose-800",
  DEADLINE_CHANGE: "bg-yellow-100 text-yellow-800",
};
